// removed by extract-text-webpack-plugin
module.exports = {"xrColorPrimary":"#2362FB"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/xr-theme.scss
// module id = ev3J
// module chunks = 232